import moment from 'moment';
import { formatMoneyLegacy } from './currency';

export function txDescription(transaction) {
	if (transaction?.remarks) return transaction.remarks;
	if (transaction?.direction === 'debit') {
		if (transaction.payment_mode) {
			return `Payout (${String(transaction.payment_mode).replace(/_/g, ' ')})`;
		}
		return 'Payout from Visit All Nepal';
	}
	return '—';
}

/** Net of credits minus debits. */
export function netLedgerAmount(transactions) {
	return (transactions || []).reduce((sum, tx) => {
		const amt = Number(tx.amount) || 0;
		return sum + (tx.direction === 'credit' ? amt : -amt);
	}, 0);
}

/** Balance carried in before the selected month (within loaded year data). */
export function openingBalanceBeforeMonth(transactions, year, month) {
	if (!month) return 0;
	const cutoff = `${year}-${String(month).padStart(2, '0')}`;
	return netLedgerAmount(
		(transactions || []).filter((tx) => moment(tx.created_at).format('YYYY-MM') < cutoff)
	);
}

export function ledgerTotals(transactions) {
	let credit = 0;
	let debit = 0;
	(transactions || []).forEach((tx) => {
		const amt = Number(tx.amount) || 0;
		if (tx.direction === 'credit') credit += amt;
		else debit += amt;
	});
	return { credit, debit };
}

export function sortLedgerAsc(transactions) {
	return [...(transactions || [])].sort(
		(a, b) => new Date(a.created_at) - new Date(b.created_at)
	);
}

export function formatLedgerAmount(amount, currencyCode, { signed = false, isCredit = true } = {}) {
	const formatted = formatMoneyLegacy(Math.abs(amount), currencyCode || 'USD');
	if (!signed) return formatted;
	return `${isCredit ? '+' : '−'}${formatted}`;
}

/** Prefer API balance_after; fall back to client-side running total. */
export function balanceAfterForTransaction(transaction, allTransactions) {
	if (transaction?.balance_after != null) return Number(transaction.balance_after);
	const sorted = sortLedgerAsc(allTransactions);
	let balance = 0;
	for (const tx of sorted) {
		const amt = Number(tx.amount) || 0;
		balance += tx.direction === 'credit' ? amt : -amt;
		if (tx.idx === transaction.idx) break;
	}
	return balance;
}
